import { DateTime } from "luxon"
import { useAsclepius } from "@/composables/api/asclepius"
import store from "@/store"

const state = () => ({
  overdueEncountersCount: 0
})

const getters = {}

const actions = {
  async getOverdueEncountersCount({ commit }) {
    const { getEncounterApi, callWithResponse } = useAsclepius()
    if (!store.getters["me/provider"]) throw new Error("Cannot get overdue Encounters for non-providers")

    let request = {
      providerId: store.getters["me/provider"].id,
      missingHpi: true,
      endDatetime: DateTime.now().minus({ hours: 12 }).toString(),
      cancelled: false
    }

    try {
      const response = await callWithResponse(() => getEncounterApi().listEncounters(request))
      commit("setOverdueEncountersCount", {
        count: response.count
      })
    } catch (e) {
      console.error(e)
      return e
    }
  }
}

const mutations = {
  setOverdueEncountersCount(state, { count }) {
    state.overdueEncountersCount = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
